import { render, staticRenderFns } from "./VoucherTransaction.vue?vue&type=template&id=20c2c682"
import script from "./VoucherTransaction.vue?vue&type=script&lang=js"
export * from "./VoucherTransaction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports